/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PayoutSummaryDto = {
    /**
     * Payout UUID
     */
    id: string;
    /**
     * Payout status: pending, paid, bank_settled, failed, on_hold
     */
    status: string;
    /**
     * Which rail this payout uses. manual_bank means there is no Stripe receipt; show the bank reference number instead.
     */
    payoutMethod: PayoutSummaryDto.payoutMethod;
    /**
     * Stripe-hosted receipt URL. Only populated for stripe_connect payouts.
     */
    receiptUrl?: string | null;
    /**
     * Corporate bank transfer reference. Only populated for manual_bank payouts after settlement.
     */
    bankReferenceNumber?: string | null;
};
export namespace PayoutSummaryDto {
    /**
     * Which rail this payout uses. manual_bank means there is no Stripe receipt; show the bank reference number instead.
     */
    export enum payoutMethod {
        STRIPE_CONNECT = 'stripe_connect',
        MANUAL_BANK = 'manual_bank',
    }
}

